<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/apms')">Taquillas</a>
    </div>
    <h1 class="ui header"><img class="ui image" src="../../assets/apm.png">
      <div class="content">Taquillas</div>
    </h1>
    <button class="ui basic button rightButton" v-on:click="exportToCSV()">
      <i class="cloud download icon"></i>Exportar listado
    </button>
    <div v-if="!apms" class="ui active centered inline loader"></div>
    <div v-if="apms" class="ui stackable one column divided grid container">
      <div class="row">
        <div class="column">
          <table class="ui very basic compact selectable collapsing  table">
            <thead>
              <tr>
                <th class="azpian">Lista de taquillas activas</th>
                <th class="right aligned">
                  <div class="ui category search">
                    <div class="ui icon input field">
                      <input class="prompt" type="text" v-model="search" placeholder="Buscar taquilla"
                        @change="filteredList">
                      <i class="search icon"></i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="apm in apms" :key="apm.id">
                <td>
                  <h4 class="ui image header">
                    <img class="ui mini image" src="../../assets/apm.png">
                    <div class="content">
                      <div class="header">{{ apm.LanguagesApts[0].name }}</div>
                      <div class="sub header">{{ apm.Apt.address }}, {{ apm.Apt.group }},
                        {{ apm.Apt.subgroup }},{{ apm.Apt.postal_code }}</div>
                    </div>
                  </h4>
                </td>
                <td>
                  <div v-if="role !== 'shophapiickPoint'" class="ui button green"
                    v-on:click="goTo('/apms/parcels/' + apm.Apt.id)">Paquetes</div>
                  <div class="ui orange button" v-on:click="goTo('/apms/stats/' + apm.Apt.id)">Estadísticas</div>
                  <div v-if="role === 'master' || role === 'admin'" class="ui button"
                    v-on:click="goTo('/apms/info/' + apm.Apt.id)">+info</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'Apms',
  data() {
    return {
      apms: null,
      search: null,
      role: null
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role
    this.getUsersApms()
  },
  methods: {
    getUsersApms() {
      hapiickApi().post('/v1/users/apms', {
        admin_id: JSON.parse(localStorage.admin).id
      })
        .then(request => this.apms = JSON.parse(JSON.stringify(request.data.data.apms)))
        .catch(() => console.log('error getting apms'))
    },
    goTo(where) {
      //this.$router.push(where)
      let routeData = this.$router.resolve(where);
      window.open(routeData.href, '_blank');
    },
    filteredList() {
      let apmlist = []
      if (this.search.length == 0) {
        this.getUsersApms()
      }
      for (var i = 0; i < this.apms.length; i++) {
        if (this.apms[i].LanguagesApts[0].name.toLowerCase().includes(this.search.toLowerCase()))
          apmlist.push(this.apms[i])
      }
      this.apms = apmlist
    },
    exportToCSV() {
      let filename = 'apmList.csv'
      var csv = []
      this.apms
      csv.push('name,address,city,province,cp')
      for (var i = 0; i < this.apms.length; i++) {
        csv.push((this.apms[i].LanguagesApts[0].name).replace(/,/g, '') + ',' + (this.apms[i].Apt.address).replace(/,/g, '') + ',' + this.apms[i].Apt.group + ',' + this.apms[i].Apt.subgroup + ',' + this.apms[i].Apt.postal_code)
      }
      // download csv file
      this.downloadCSV(csv.join("\n"), filename)
    },
    downloadCSV(csv, filename) {
      var csvFile;
      var downloadLink;
      if (window.Blob == undefined || window.URL == undefined || window.URL.createObjectURL == undefined) {
        alert("Your browser doesn't support Blobs");
        return;
      }

      csvFile = new Blob([csv], {
        type: "text/csv"
      });
      downloadLink = document.createElement("a");
      downloadLink.download = filename;
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Apms/Apms.vue